"use client";

import type { HelpImage } from "@/lib/help/articles";

type Props = {
  images?: HelpImage[];
  /** Compact spacing for the side help panel */
  compact?: boolean;
};

/** Gallery of UI screenshots / schemas inside a help article. */
export function HelpArticleImages({ images, compact }: Props) {
  if (!images?.length) return null;

  return (
    <div className={compact ? "mb-4 space-y-3" : "space-y-4"}>
      {images.map((img) => (
        <figure key={img.src} className="overflow-hidden rounded-lg border border-keiro-green/10 bg-keiro-mist/20">
          {/* eslint-disable-next-line @next/next/no-img-element -- static public/help assets */}
          <img
            src={img.src}
            alt={img.alt}
            loading="lazy"
            decoding="async"
            className="block h-auto w-full max-w-full object-contain object-top"
          />
          {img.caption ? (
            <figcaption
              className={`border-t border-keiro-green/10 px-3 text-keiro-gray-600 ${
                compact ? "py-1.5 text-xs" : "py-2 text-xs sm:text-sm"
              }`}
            >
              {img.caption}
            </figcaption>
          ) : null}
        </figure>
      ))}
    </div>
  );
}
